import { Observable, Subject } from 'rxjs';
import { Type } from '@angular/core';

export class DialogRef {
  form?:any = {};
  component?: Type<any>|any;
  constructor() {}

  close(result?: any) {
    this._afterClosed.next(result);
  }

  private readonly _afterClosed = new Subject<any>();
  afterClosed: Observable<any> = this._afterClosed.asObservable();

  setChildComponent(result?: any) {
    this.component = result;
    this._loadChildComponent.next(result);
  }
  private readonly _loadChildComponent = new Subject<any>();
  onSuccess: Observable<any> = this._loadChildComponent.asObservable();

}
